import { render, staticRenderFns } from "./ed-h3.vue?vue&type=template&id=10e5e3f5&scoped=true&"
import script from "./ed-h3.ts?vue&type=script&lang=js&"
export * from "./ed-h3.ts?vue&type=script&lang=js&"
import style0 from "./ed-h3.scss?vue&type=style&index=0&id=10e5e3f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5e3f5",
  null
  
)

export default component.exports